module.exports = __webpack_public_path__ + "static/media/208-Arzt_ID_1.80ed69e1.mp3";